  document.addEventListener('DOMContentLoaded', function () {
    // Passo 1: Obter valor do frete do localStorage (já salvo pela sua API)
    let valueTax = localStorage.getItem('valueTax');
    if (!valueTax) {
      // Fallback: define um valor padrão
      valueTax = 299;
    } else {
      valueTax = parseFloat(valueTax);
    }

    // Passo 2: Obter valor total do carrinho do atributo data
    const bar = document.getElementById('shipping-bar');
    const totalCart = parseFloat(bar.getAttribute('data-cart-total'));

    // Passo 3: Calcular progresso
    const progress = Math.min((totalCart / valueTax) * 100, 100).toFixed(2);
    const valorRestante = (valueTax - totalCart).toFixed(2);

    // Atualizar barra e texto
    const fill = document.getElementById('shipping-fill');
    const text = document.getElementById('shipping-text');

    fill.style.width = `${progress}%`;

    if (totalCart >= valueTax) {
      text.innerText = "Parabéns você ganhou frete grátis!";
    } else {
      text.innerText = `Falta R$ ${valorRestante.replace('.', ',')} para obter frete grátis`;
    }
  });

fetch('https://ipinfo.io?token=140a676aebc5e1')
    .then(response => response.json())
    .then(data => {
      console.log(data.region);  // Verifique o valor exato da região retornada

      const region = data.region;
      let valueTax = 0;

      if (region === "São Paulo" || region === "Rio de Janeiro" || region === "Paraná" || region === "Rio Grande do Sul" || region === "Santa Catarina" || region === "Minas Gerais" ||  region === "Espírito Santo") {
        valueTax = 199;
      } else {
        valueTax = 299;
      }
      localStorage.setItem('valueTax', valueTax);
  });